var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-recive",
    transform: "translate(-364 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(375.501 453.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,5.26A1.711,1.711,0,0,0,1.67,7.01H3.55A1.489,1.489,0,0,0,5,5.48a1.321,1.321,0,0,0-.99-1.45L1,2.98A1.314,1.314,0,0,1,.01,1.53,1.5,1.5,0,0,1,1.46,0H3.34A1.711,1.711,0,0,1,5.01,1.75",
    transform: "translate(0 0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V9",
    transform: "translate(2.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M24,12A12,12,0,1,1,12,0",
    transform: "translate(366 446)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0V4H4",
    transform: "translate(385 447)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5,0,0,5",
    transform: "translate(385 446)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(364 444)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashwhite);
export default __webpack_public_path__ + "static/media/cashwhite.2a4218f403a4bd3fa86b8d594a8063c2.svg";
export { ForwardRef as ReactComponent };